export default function DownLoadIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_611_474)">
        <path
          d="M15.834 15H4.16732C3.70708 15 3.33398 15.3731 3.33398 15.8333C3.33398 16.2936 3.70708 16.6667 4.16732 16.6667H15.834C16.2942 16.6667 16.6673 16.2936 16.6673 15.8333C16.6673 15.3731 16.2942 15 15.834 15Z"
          fill="black"
        />
        <path
          d="M3.33398 14.1641V15.8307C3.33398 16.291 3.70708 16.6641 4.16732 16.6641C4.62756 16.6641 5.00065 16.291 5.00065 15.8307V14.1641C5.00065 13.7038 4.62756 13.3307 4.16732 13.3307C3.70708 13.3307 3.33398 13.7038 3.33398 14.1641Z"
          fill="black"
        />
        <path
          d="M15 14.1641V15.8307C15 16.291 15.3731 16.6641 15.8333 16.6641C16.2936 16.6641 16.6667 16.291 16.6667 15.8307V14.1641C16.6667 13.7038 16.2936 13.3307 15.8333 13.3307C15.3731 13.3307 15 13.7038 15 14.1641Z"
          fill="black"
        />
        <path
          d="M9.99988 12.5026C9.82711 12.5039 9.65821 12.4515 9.51654 12.3526L6.18321 10.0026C6.00355 9.87516 5.88166 9.68177 5.84419 9.46471C5.80671 9.24765 5.85669 9.02458 5.98321 8.84427C6.04637 8.75415 6.12675 8.67742 6.21972 8.61853C6.31268 8.55964 6.4164 8.51974 6.52486 8.50114C6.63333 8.48255 6.74441 8.48562 6.85169 8.51019C6.95896 8.53476 7.06031 8.58033 7.14988 8.64427L9.99988 10.6359L12.8332 8.50261C13.01 8.37 13.2323 8.31306 13.4511 8.34432C13.6699 8.37557 13.8673 8.49246 13.9999 8.66927C14.1325 8.84608 14.1894 9.06833 14.1582 9.28713C14.1269 9.50592 14.01 9.70333 13.8332 9.83594L10.4999 12.3359C10.3556 12.4441 10.1802 12.5026 9.99988 12.5026Z"
          fill="black"
        />
        <path
          d="M9.99935 10.8333C9.77834 10.8333 9.56637 10.7455 9.41009 10.5893C9.25381 10.433 9.16602 10.221 9.16602 10V3.33333C9.16602 3.11232 9.25381 2.90036 9.41009 2.74408C9.56637 2.5878 9.77834 2.5 9.99935 2.5C10.2204 2.5 10.4323 2.5878 10.5886 2.74408C10.7449 2.90036 10.8327 3.11232 10.8327 3.33333V10C10.8327 10.221 10.7449 10.433 10.5886 10.5893C10.4323 10.7455 10.2204 10.8333 9.99935 10.8333Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_611_474">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
